import React, { useState, useEffect } from "react";
import Layout from "../layout/Layout";
import { VscCircleFilled } from "react-icons/vsc";

import axiosInstance from "../../apiInstances/axiosInstance";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { toast } from "react-toastify";
import io from "socket.io-client";
import { AiOutlinePlus, AiFillDelete } from "react-icons/ai";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
const NotificationUser = () => {
  const { decryptData } = useEncryption();

  const [allNotification, setAllNotification] = useState([]); // use User Table time this state
  const [showModal, setShowModal] = React.useState(false); // Delete Popup
  const userId = localStorage.getItem("Token");

  console.log(userId, "--------");
  const getNotificationdata = async () => {
    let apiEndpoint = "/mynotifications";

    try {
      const res = await axiosInstanceAuth.get(apiEndpoint);
      const myData = decryptData(res?.data?.data);

      const userNotifications = myData?.data.filter(
        (allNotification) => allNotification.role === "user"
      );
      setAllNotification(userNotifications || []);
      console.log("Notification Show User---->", userNotifications);
    } catch (err) {
      console.log("err --->", err);
    }
  };

  useEffect(() => {
    getNotificationdata();
  }, []);
  useEffect(() => {
    const socket = io(BACKEND_BASE_URL);
    socket.emit("join", {
      userid: userId,
    });

    console.log("====================================> messagrrrrrrr");
    //Handle incoming notifications
    socket.on("new_notification", (message) => {
      console.log("Received notification:", message);

      const userNotifications = message.filter(
        (allNotification) => allNotification.role === "user"
      );
      setAllNotification([...userNotifications]);
    });

    //Clean up the socket connection on component unmount

    return () => {
      socket.disconnect();
      console.log("Socket disconnected on component unmount");
    };
  }, []);
  // Delete API
  const clearNotificationApi = async () => {
    await axiosInstanceAuth
      .post(`/clearnotification_admin`, { role: "user" })
      .then((res) => {
        const myClearData = decryptData(res?.data?.data);
        console.log("Clear Notification Done --->", myClearData);
        if (myClearData.status) {
          getNotificationdata();
          toast.success(myClearData?.message);
        } else {
          toast.error(myClearData?.message);
        }
        setShowModal(false);
      })
      .catch((err) => {
        console.log("err --->", err);
      });
  };

  const renderNotifications = () => {
    if (!Array.isArray(allNotification) || allNotification.length === 0) {
      return (
        <div className="">
          <div className="text-5xl font-sans font-bold text-center mt-80 text-[#22345C]">
            No Notification !
          </div>
        </div>
      );
    }

    let currentDate = null;

    return allNotification?.map((notification, index) => {
      const isNewDate = notification.date !== currentDate;

      if (isNewDate) {
        currentDate = notification.date;
      }

      return (
        <div
          key={index}
          className={`mt-5 space-y-3 ${isNewDate ? "border-t pt-3" : ""}`}
        >
          {isNewDate && (
            <div className="text-[#22345C] font-sans font-semibold">
              {notification.date}
            </div>
          )}
          <div className="rounded-md shadow-lg flex items-center gap-2 bg-white px-3 py-3">
            <div>
              <VscCircleFilled size={20} className="text-[#22345C]" />
            </div>
            <div className="font-medium font-sans text-base text-justify">
              {notification.message}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="md:flex justify-between  mt-8">
        <div className="flex lg:text-[30px] text-[20px] font-semibold gap-3 justify-center items-center">
          <h1 className="text-[#22345C]">Notification</h1>
        </div>
        <div className="flex justify-center items-center">
          <div className="flex justify-center  items-center">
            {allNotification.length > 0 && (
              <button
                onClick={() => setShowModal(true)}
                class="bg-[#22345C]  text-white font-sans font-bold py-2 px-4 rounded-lg"
              >
                Clear All
              </button>
            )}
            {showModal ? (
              <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                  <div className="relative w-auto my-6 mx-auto max-w-3xl">
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                      <div className="relative p-6 flex-auto">
                        <span className="justify-center items-center flex">
                          <AiFillDelete className="w-16 h-16 fill-red-500" />
                        </span>
                        <p className="my-4 text-center leading-relaxed text-2xl text-red-500">
                          Are You Sure ?
                        </p>
                        <p className="my-4 text-slate-500 text-lg leading-relaxed">
                          You want to Clear this All Notification
                        </p>
                      </div>

                      <div className="flex gap-2 items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b">
                        <button
                          onClick={() => setShowModal(false)}
                          class="text-red-500   font-bold py-2 px-6 rounded"
                        >
                          No
                        </button>
                        <button
                          onClick={clearNotificationApi}
                          class="bg-emerald-500 active:bg-emerald-600 px-6 py-2  text-white font-bold rounded"
                        >
                          Yes
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
              </>
            ) : null}
          </div>
        </div>
      </div>

      <div>{renderNotifications()}</div>
    </>
  );
};

export default NotificationUser;
